import axios from 'axios'
import HTTP from './http'

export default {
    getStatistics: params => axios.get(HTTP.STATISTICS, { params })
}
